/* 公众号菜单管理 */
export const GETMENULIST = 'GETMENULIST' // 获取菜单列表
export const UPDATEBUTTON = 'UPDATEBUTTON' // 更新菜单
export const DELETEBUTTON = 'DELETEBUTTON' // 删除菜单
export const APPLYBUTTON = 'APPLYBUTTON' // 刷新应用



// WEBPACK FOOTER //
// ./src/store/officeButtonManage/types.js